import { createAction } from '@reduxjs/toolkit';

export const treeRemoveItems = createAction(
  'tree/removeItems',
  (tree, itemGroups) => ({
    meta: { tree },
    payload: { itemGroups },
  }),
);
